import React from "react";

const ZaloIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      x="0px"
      y="0px"
      width="100"
      height="100"
      viewBox="0 0 24 24"
    >
      <path
        fill="#0068FF"
        d="M15.946,12.988c-0.69,0-1.252-0.562-1.252-1.252s0.562-1.252,1.252-1.252	c0.69,0,1.252,0.562,1.252,1.252S16.637,12.988,15.946,12.988z M15.946,10.984c-0.414,0-0.751,0.337-0.751,0.751	s0.337,0.751,0.751,0.751s0.751-0.337,0.751-0.751S16.36,10.984,15.946,10.984z"
      ></path>
      <path
        fill="#0068FF"
        d="M14.193,12.988h-0.334c-0.092,0-0.167-0.075-0.167-0.167V9.982h0.501V12.988z"
      ></path>
      <path
        fill="#0068FF"
        d="M12.691,10.567v0.173c-0.21-0.159-0.468-0.257-0.751-0.257c-0.69,0-1.252,0.562-1.252,1.252	s0.562,1.252,1.252,1.252c0.283,0,0.541-0.098,0.751-0.257v0.09c0,0.092,0.075,0.167,0.167,0.167h0.334v-2.421H12.691z M11.939,12.487c-0.414,0-0.751-0.337-0.751-0.751s0.337-0.751,0.751-0.751s0.751,0.337,0.751,0.751S12.353,12.487,11.939,12.487z"
      ></path>
      <path
        fill="#0068FF"
        d="M10.771,9.982H8.099v0.501h1.777l-1.86,2.171h0.009c-0.054,0.07-0.092,0.155-0.092,0.25v0.083h2.504	c0.092,0,0.167-0.075,0.167-0.167v-0.334H8.827l1.86-2.171h-0.009c0.054-0.07,0.092-0.155,0.092-0.25V9.982z"
      ></path>
      <path
        fill="none"
        stroke="#0068FF"
        d="M17,20H7c-1.657,0-3-1.343-3-3V7	c0-1.657,1.343-3,3-3h10c1.657,0,3,1.343,3,3v10C20,18.657,18.657,20,17,20z"
      ></path>
      <path
        fill="#0068FF"
        d="M13.16,20.27c-1.748,0-3.547,0.639-5.088-0.207l-3.397-0.621l-0.386-2.914 c-1.077-1.682-0.718-3.662-0.718-5.663c0-2.367-0.113-4.637,1.365-6.48L8.142,4.68c-2.328,1.105-3.177,4.124-3.177,5.991 c0,3.087,1.472,4.79,1.472,4.79l-0.425,1.943c-0.064,0.357,0.26,0.662,0.613,0.576l1.712-0.545c0,0,2.292,1.564,4.663,1.564 c5.198,0,6.385-2.462,6.385-2.462l0.229,2.526C17.771,20.542,15.525,20.27,13.16,20.27z"
      ></path>
    </svg>
  );
};

export default ZaloIcon;
